export const API_BASE = process.env.VUE_APP_APP_BASE_URL;
